export interface IAddEditData {
    [key: string]: any,
    abo: number,
    ckdStatus: number,
    status: number,
    type: number,
    gender: number,
    firstName: string,
    lastName: string,
    country: number,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateProvince: string,
    postalCode: string,
    phoneNumberPrimary: string,
    phoneNumberSecondary: string,
    emailPrimary: string,
    emailSecondary: string,
    birthDate: string,
}